import * as React from 'react';

import { EMediaType, IGallerySlide } from '../../../../types/project';
import {
  CarouselNoMedia,
  Carousel,
  LayoutButton,
  CarouselItemWrapper,
  CarouselItem,
} from '../../../../components/Carousel';
import { useGalleryData } from '../../../../hooks';

interface ICarouselSliderProps {
  sliderRef: React.MutableRefObject<HTMLUListElement | null>;
  onSlideClick(slide: IGallerySlide, index: number): void;
}

export const CarouselSliderContainer = ({ sliderRef, onSlideClick }: ICarouselSliderProps) => {
  const { slides } = useGalleryData({ withTour: true });

  const layoutSlideIndex = React.useMemo(
    () => slides.findIndex((m: IGallerySlide) => m.type === EMediaType.Layout),
    [slides],
  );

  const hasLayoutButton = layoutSlideIndex >= 0;

  const layoutRef = React.useRef<HTMLDivElement | null>(null);

  const onLayoutClick = React.useCallback(() => {
    if (layoutRef && layoutRef.current && hasLayoutButton) {
      layoutRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'center',
      });
    }
  }, [hasLayoutButton]);

  if (slides.length === 0) {
    return <CarouselNoMedia />;
  }

  return (
    <Carousel sliderRef={sliderRef} action={hasLayoutButton && <LayoutButton onClick={onLayoutClick} />}>
      {slides.map((slide, i) => (
        <CarouselItemWrapper
          ref={i === layoutSlideIndex ? layoutRef : undefined}
          key={slide.full + i}
          onClick={() => onSlideClick(slide, i)}
          dataName={`slide_${i}`}
        >
          <CarouselItem slide={slide} lazy={i > 1} />
        </CarouselItemWrapper>
      ))}
    </Carousel>
  );
};
